import { Loader } from "@/components/loader";
import "./loading-screen.css";

export function LoadingScreen() {
  return (
    <div className="loading-screen">
      <Loader/>
    </div>
  );
}